import { Configuration, LogLevel } from '@azure/msal-browser';

// Log configuration values for debugging
console.log('%c[AUTH CONFIG] Initializing MSAL configuration', 'color: blue; font-weight: bold');
console.log('CLIENT_ID:', process.env.REACT_APP_AZURE_CLIENT_ID ? '✓ Set' : '✗ Missing');
console.log('AUTHORITY:', process.env.REACT_APP_AZURE_AUTHORITY ? '✓ Set' : '✗ Missing');
console.log('REDIRECT_URI:', process.env.REACT_APP_REDIRECT_URI || window.location.origin);
console.log('API_SCOPE:', process.env.REACT_APP_API_SCOPE ? '✓ Set' : '✗ Missing');

// Azure AD Configuration
// Get these values from Azure Portal -> Azure Active Directory -> App Registrations
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: process.env.REACT_APP_AZURE_AUTHORITY || '',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Must be a scope exposed on this app's OWN API (Azure Portal > App
// registrations > this app > Expose an API), NOT a Microsoft Graph scope
// like User.Read. Graph's User.Read + offline_access triggers the generic
// "this app would like to... maintain access to data" consent screen every
// time a fresh interactive grant is needed; a custom scope on our own app
// consents once as "Access <appname>" and persists via the cached refresh
// token, matching the working setup in C:\code\dqmonitor.
const API_SCOPE = process.env.REACT_APP_API_SCOPE || 'api://4cbe4c19-4706-4653-84e3-863870859184/access_as_user';

export const loginRequest = {
  scopes: [API_SCOPE],
};

export const apiScopes = {
  scopes: [API_SCOPE],
};
